var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMotorbike({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.00008 8.33333H13.7501L10.4167 11.6667H6.25008L9.58342 8.33333M10.8334 5H12.5001L15.4167 10.8333M1.66675 13.3333C1.66675 13.9964 1.93014 14.6323 2.39898 15.1011C2.86782 15.5699 3.50371 15.8333 4.16675 15.8333C4.82979 15.8333 5.46567 15.5699 5.93452 15.1011C6.40336 14.6323 6.66675 13.9964 6.66675 13.3333C6.66675 12.6703 6.40336 12.0344 5.93452 11.5656C5.46567 11.0967 4.82979 10.8333 4.16675 10.8333C3.50371 10.8333 2.86782 11.0967 2.39898 11.5656C1.93014 12.0344 1.66675 12.6703 1.66675 13.3333ZM13.3334 13.3333C13.3334 13.9964 13.5968 14.6323 14.0656 15.1011C14.5345 15.5699 15.1704 15.8333 15.8334 15.8333C16.4965 15.8333 17.1323 15.5699 17.6012 15.1011C18.07 14.6323 18.3334 13.9964 18.3334 13.3333C18.3334 12.6703 18.07 12.0344 17.6012 11.5656C17.1323 11.0967 16.4965 10.8333 15.8334 10.8333C15.1704 10.8333 14.5345 11.0967 14.0656 11.5656C13.5968 12.0344 13.3334 12.6703 13.3334 13.3333Z",
    stroke: "#CCCCCC",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMotorbike);
export default __webpack_public_path__ + "static/media/motorbike.a50619614ff831f1459131e4c28bb536.svg";
export { ForwardRef as ReactComponent };